<template>
    <v-container fluid>
        <h1>Speedy Board</h1>
        <v-row>
            <v-col cols="6">
                <v-toolbar>
                    <v-menu
                            ref="menu"
                            v-model="pickerOpen"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                    v-model="formattedDate"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    max-width="290px"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                                :multiple="pickerRange"
                                :range="pickerRange"
                                :show-week="true"
                                :type="pickerType"
                                @change="[updatePeriod, pickerOpen = false]"
                                first-day-of-week="1"
                                v-model="date"
                        >
                        </v-date-picker>
                    </v-menu>
                    <v-btn-toggle
                            v-model="selectedType"
                            tile
                            group
                            mandatory
                            @change="selectType(selectedType)"
                    >
                        <v-btn value="date">
                            Day
                        </v-btn>

                        <v-btn value="week">
                            Week
                        </v-btn>

                        <v-btn value="month">
                            Month
                        </v-btn>

                    </v-btn-toggle>
                    <v-btn class="mr-2" @click="previous">
                        <v-icon>mdi-chevron-left</v-icon>
                    </v-btn>
                    <v-btn @click="next">
                        <v-icon>mdi-chevron-right</v-icon>
                    </v-btn>

                </v-toolbar>
            </v-col>
        </v-row>

        <div class="d-flex flex-row">
            <h2 class="mr-2">{{title}}</h2>

        </div>
        <v-progress-linear
                :active="$apollo.loading"
                :indeterminate="$apollo.loading"
                color="indigo accent-4"
        ></v-progress-linear>
        <v-simple-table>
            <template v-slot:default>
                <thead>
                <tr>
                    <th class="text-left">Class</th>
                    <th class="text-left">Date</th>
                    <th class="text-left">Trainer</th>
                    <th class="text-left">Course</th>
                    <th class="text-left">Company</th>
                    <th class="text-left">Delegates</th>
                    <th class="text-left">Location</th>
                    <th class="text-left">Value</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="session in sessions" :key="session.id">
                    <td>
                        <v-btn :to="{ name: 'training-class', params: { id: session.trainingClass.id }}" small>
                            CL-{{session.trainingClass.id }}
                        </v-btn>
                    </td>
                    <td>{{ session.date | formatDate('ddd, D MMM') }}</td>
                    <td>{{ session.trainer.firstName }} {{ session.trainer.lastName }}</td>
                    <td>{{ session.trainingClass.title }}</td>
                    <td>{{ session.trainingClass.company }}</td>
                    <td>{{ session.trainingClass.allAttendees.length }}</td>
                    <td>{{ session.trainingClass.location }}</td>
                    <td>{{ session.trainingClass.value | toCurrency }}</td>
                </tr>
                </tbody>
            </template>
        </v-simple-table>
        <div v-if="(!sessions || sessions.length === 0) && !$apollo.loading">
            <h4>There are no classes in this period.</h4>

        </div>
    </v-container>
</template>

<script>

    import Dashboard from "../layouts/Dashboard"
    import {mapGetters} from 'vuex'
    import SESSIONS from "../graphql/TrainingSessionsAll.gql"
    import moment from 'moment'

    const DAY_DATE_FORMAT = 'YYYY-MM-DD'
    const DAY_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'
    const DAY_MONTH_FORMAT = 'YYYY-MM';
    const TODAY = moment().set({hour: 0, minute: 0, second: 0, millisecond: 0});

    export default {
        name: "speedy",
        components: {},
        metaInfo: {
            title: 'Speedy'
        },
        data() {
            let queryDate = this.$route.query.date ? moment(this.$route.query.date).set({
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0
            }) : TODAY;

            let startDate = queryDate.startOf('month').format(DAY_DATETIME_FORMAT)
            let endDate = queryDate.endOf('month').format(DAY_DATETIME_FORMAT)
            let range = false
            let date = startDate

            if (this.$route.query.selectedType && this.$route.query.selectedType === 'week') {
                endDate = queryDate.add(1, 'week').format(DAY_DATETIME_FORMAT)
                range = true
                date = [queryDate.format(DAY_DATE_FORMAT), queryDate.add(1, 'week').format(DAY_DATE_FORMAT)]
            }

            return {
                selectedType: this.$route.query.selectedType ? this.$route.query.selectedType : 'month',
                pickerType: 'month',
                pickerRange: range,
                pickerOpen: false,
                date: date,
                start: startDate,
                end: endDate,
            }
        },
        apollo: {
            sessions: {
                query: SESSIONS,
                variables() {
                    return {
                        where: {
                            "AND": [
                                {
                                    column: "DATE",
                                    operator: "GTE",
                                    value: this.start
                                },
                                {
                                    column: "DATE",
                                    operator: "LTE",
                                    value: this.end
                                }
                            ]
                        }
                    }
                },
                update: data => data.sessions
            },
        },

        watch: {

            date() {
                this.updatePeriod();
            }
        },
        computed: {
            ...mapGetters('auth', [
                'isAuthenticated',
                'getUser',
            ]),
            formattedDate() {
                if (this.selectedType === 'week') {
                    return 'Week ' + moment(this.date[0]).isoWeek();
                }

                if (this.selectedType === 'date') {
                    return moment(this.date).format("ddd, D MMMM YYYY");
                }
                if (this.selectedType === 'month') {
                    return moment(this.date).format("MMMM, YYYY");
                }
                return '';
            },
            title() {
                if (this.selectedType === 'date') {
                    return this.formattedDate
                }

                return this.formattedDate + ' (' + moment(this.start).format('L') + ' to ' + moment(this.end).format('L')+')'
            }
        },
        created() {
            this.$emit('update:layout', Dashboard);
        },
        methods: {

            selectType(newType) {

                this.date = TODAY.format(DAY_DATE_FORMAT)
                if (newType === 'week') {
                    console.log('switch to week');
                    this.pickerType = 'date';
                    this.pickerRange = true;
                    this.date = [moment().format(DAY_DATE_FORMAT)]
                }

                if (newType === 'date') {
                    this.pickerType = 'date';
                    this.pickerRange = false;

                }

                if (newType === 'month') {
                    this.pickerType = 'month';
                    this.pickerRange = false;
                }

                this.updatePeriod();
            },


            next() {
                if (this.selectedType === 'week') {
                    this.date = moment(this.date[0]).add(1, 'week').format(DAY_DATE_FORMAT);
                }
                if (this.selectedType === 'date') {
                    this.date = moment(this.date).add(1, 'days').format(DAY_DATE_FORMAT);
                }
                if (this.selectedType === 'month') {
                    this.date = moment(this.date).add(1, 'month').format(DAY_MONTH_FORMAT)
                }
                this.updatePeriod();
            },

            previous() {
                if (this.selectedType === 'week') {
                    this.date = moment(this.date[0]).subtract(1, 'week').format(DAY_DATE_FORMAT);
                }
                if (this.selectedType === 'date') {
                    this.date = moment(this.date).subtract(1, 'days').format(DAY_DATE_FORMAT);
                }
                if (this.selectedType === 'month') {
                    this.date = moment(this.date).subtract(1, 'month').format(DAY_MONTH_FORMAT)
                }
                this.updatePeriod();
            },

            updatePeriod() {

                if (this.selectedType === 'week') {
                    let firstSelectedDate;
                    if (Array.isArray(this.date)) {
                        firstSelectedDate = moment(this.date[0])
                    } else {
                        firstSelectedDate = moment(this.date)
                    }

                    this.start = firstSelectedDate.startOf('week').format(DAY_DATE_FORMAT);
                    this.end = firstSelectedDate.endOf('week').format(DAY_DATE_FORMAT);


                    if (this.date[0] !== this.start || this.date[1] !== this.end) {
                        this.date = [this.start, this.end]
                    }
                } else {
                    if (Array.isArray(this.date)) {
                        this.date = this.date[0];
                    }

                    if (this.selectedType === 'date') {
                        this.start = moment(this.date).format(DAY_DATETIME_FORMAT);
                        this.end = this.start;
                    }


                    if (this.selectedType === 'month') {
                        let month = moment(this.date)
                        this.start = month.startOf('month').format(DAY_DATETIME_FORMAT);
                        this.end = month.endOf('month').format(DAY_DATETIME_FORMAT);
                    }
                }

                this.$router.push({
                    name: 'speedy',
                    query: {
                        date: Array.isArray(this.date) ? this.date[0] : this.date,
                        selectedType: this.selectedType
                    }
                }).catch(() => {})

            }
        }
    };
</script>
